import React from 'react';
import Header from '../components/Header';
import SearchBar from '../components/SearchBar';
import Result from '../components/ShowResult';
import { useState,useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';

const MainPage = () => {

  const [youtubeLink, setYoutubeLink] = useState(''); // State to store the YouTube link

  // const [youtubeLink, setYoutubeLink] = useState('');
  const handleAnalyze = (youtubeLink) => {
    if (youtubeLink) {
      console.log("Analyzing:", youtubeLink);
      setYoutubeLink(youtubeLink); // Set the YouTube link in state
      // Save the link to localStorage so that it persists
      // localStorage.setItem("lastSearchedLink", youtubeLink);
    } else {
      console.log("Invalid YouTube link");
    }
  };

  useEffect(() => {
    // On mount, check if there's a stored YouTube link and pass it to Result
    const storedLink = localStorage.getItem("lastSearchedLink");
    if (storedLink) {
      setYoutubeLink(storedLink);
    }
  }, []);

  return (
    <div className="wrapper">
      {/* <Header onLoginClick={handleLoginClick} onLogoutClick={handleLogoutClick}/> */}
      <div className="content">
            <Header/>
            <SearchBar onAnalyze={handleAnalyze} />
          

            <Result youtubeLink={youtubeLink}/>
      </div>
   
    </div>
  );
};

export default MainPage;
